import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAddressStages = async () => {
  return await request.get(
    `/FlatsGrid/address_stages`,
    {},
    'При загрузке возможных состояний квартир произошла ошибка',
    []
  );
};

const useAddressStages = (options) =>
  useQuery(getQueryKeys.addressStages(), getAddressStages, options);

export default useAddressStages;
